module.exports = __webpack_public_path__ + "img/home_background.92094e36.jpg";